import { render, staticRenderFns } from "./LetterBlack.vue?vue&type=template&id=d39af338&scoped=true&"
var script = {}
import style0 from "./LetterBlack.vue?vue&type=style&index=0&id=d39af338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39af338",
  null
  
)

export default component.exports